import { trackEvent } from 'integrations/metrics';
import { EventNames } from 'integrations/metrics/events';
import { EventAction, EventObjectType } from 'integrations/metrics/types';

type TSegmentStepEvents = {
  [key: string]: {
    action: EventAction;
    eventName: EventNames;
    objectType: EventObjectType;
    objectValue?: string;
  };
};

const segmentStepEvents: TSegmentStepEvents = {
  'select-location': {
    action: EventAction.VIEW,
    eventName: EventNames.WAITLIST_VIEW_LOCATION_STEP,
    objectType: EventObjectType.PAGE,
    objectValue: 'Address Step',
  },
  'personal-info': {
    action: EventAction.VIEW,
    eventName: EventNames.WAITLIST_VIEW_INFORMATION_STEP,
    objectType: EventObjectType.PAGE,
    objectValue: 'Client Info Step',
  },
  success: {
    action: EventAction.ADD,
    eventName: EventNames.WAITLIST_JOIN_SUCCESS,
    objectType: EventObjectType.WAITLIST_DATA,
  },
  error: {
    action: EventAction.ADD,
    eventName: EventNames.WAITLIST_JOIN_ERROR,
    objectType: EventObjectType.WAITLIST_DATA,
  },
};

export const trackButtonClick = (totalPrice: number) =>
  trackEvent(EventNames.WAITLIST_BUTTON_CLICKED, {
    action: EventAction.SELECT,
    productSection: 'Waitlists',
    productSubSection: 'Registration',
    objectType: EventObjectType.BUTTON,
    dollarValue: totalPrice,
  });

export const trackWaitlistStep = (step: string, totalPrice: number) => {
  const event = segmentStepEvents[step];

  if (!event) {
    return false;
  }

  return trackEvent(event.eventName, {
    action: event.action,
    productSection: 'Waitlists',
    productSubSection: 'Registration',
    objectType: event.objectType,
    dollarValue: totalPrice,
    ...(event.objectValue && { objectValue: event.objectValue }),
  });
};
